import Promise from 'es6-promise';
(window as any).Promise = Promise;
